// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Headers__root___Fnzju {\n  width: 100px;\n  flex-shrink: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Editor/Toolbar/modules/Headers/Headers.styl"],"names":[],"mappings":"AAAA;EACE,YAAM;EACN,cAAY;AACd","sourcesContent":[".root\n  width 100px\n  flex-shrink 0\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Headers__root___Fnzju"
};
export default ___CSS_LOADER_EXPORT___;
